import { useModal, useRequest } from '@stores';
import { ModalContent, ModalFooter } from '@components/modal';
import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

const NavbarNavigateWarningModal = ({ url, openInNewTab }) => {
  const { closeModal } = useModal();
  const isReadOnly = useRequest((state) => state.isFormReadOnly);
  const navigate = useNavigate();

  const isInternal = openInNewTab;

  useEffect(() => {
    if (isReadOnly) {
      if (isInternal) {
        window.open(url, '_blank');
      } else {
        navigate({ to: url });
      }
      closeModal();
    }
  }, [isReadOnly, isInternal, url, navigate, closeModal]);

  const handleNavigation = () => {
    closeModal();

    if (isInternal) {
      window.open(url, '_blank');
    } else {
      navigate({ to: url });
    }
  };

  if (isReadOnly) {
    return null;
  }

  const displayText = isInternal ? (
    <>You are now being redirected to an external page in a new tab.</>
  ) : (
    <>
      You are about to navigate away from the forms application; any unsaved work will be lost! <br /> <br />
      Press Cancel to go back and save progress, or OK to proceed.
    </>
  );

  return (
    <ModalContent size='md' title={isInternal ? 'External Resource' : 'Warning!'}>
      <section className='modal-body'>
        <div className='text-bold font-ui-md'>{displayText}</div>
      </section>
      <ModalFooter onSave={handleNavigation} onCancel={closeModal} saveText='OK' customSaveLogic />
    </ModalContent>
  );
};

export default NavbarNavigateWarningModal;
